import { FunctionComponent, useMemo } from 'react';

import { VisitAndAppointmentStatus } from '@dreryk/egabinet-visit-frontend-api';

import { appointmentsTranslationKeys } from '../../../translations';
import { AppointmentStatus as AppointmentStatusComponent, AppointmentStatusType } from '../../AppointmentStatus';

type StatusDisplayInfo = {
   label: string;
   statusType: AppointmentStatusType;
};

const createStatusDisplayMap = (): Record<VisitAndAppointmentStatus, StatusDisplayInfo> => ({
   REGISTERED: {
      label: appointmentsTranslationKeys.statusCode.REGISTERED,
      statusType: AppointmentStatusType.PLANNED,
   },
   CANCELLED: {
      label: appointmentsTranslationKeys.statusCode.CANCELLED,
      statusType: AppointmentStatusType.DISABLED,
   },
   IN_PROGRESS: {
      label: appointmentsTranslationKeys.statusCode.IN_PROGRESS,
      statusType: AppointmentStatusType.DURING,
   },
   FINISHED_APPROVED: {
      label: appointmentsTranslationKeys.statusCode.FINISHED_APPROVED,
      statusType: AppointmentStatusType.POSITIVE,
   },
   FINISHED_NOT_APPROVED: {
      label: appointmentsTranslationKeys.statusCode.FINISHED_NOT_APPROVED,
      statusType: AppointmentStatusType.NEGATIVE,
   },
});

const createStatus = (statusDisplayInfo: StatusDisplayInfo): JSX.Element => (
   <AppointmentStatusComponent type={statusDisplayInfo.statusType} label={statusDisplayInfo.label} />
);

type StatusProps = {
   status: VisitAndAppointmentStatus;
};

const StatusCell: FunctionComponent<StatusProps> = (props: StatusProps) => {
   const statusDisplayInfoMap = useMemo(() => createStatusDisplayMap(), []);
   // eslint-disable-next-line no-negated-condition
   const statusDisplayInfo = statusDisplayInfoMap[props.status];

   return createStatus(statusDisplayInfo);
};

export { StatusCell };
